module.exports = __webpack_public_path__ + "static/feladatkiadas_rosszul-82c7dfb0ed99d2cf6c330f7930202b70.png";